interface HasId {
  id: string;
}

interface MultiAddTableBodyProps<T extends HasId> {
  items: T[];
  addItem: (item: T) => React.JSX.Element;
}

const MultiTableBody = <T extends HasId>({
  items,
  addItem,
}: MultiAddTableBodyProps<T>) => {
  return (
    <tbody>
      {items && items.map((item) => <tr key={item.id}>{addItem(item)}</tr>)}
    </tbody>
  );
};

export default MultiTableBody;
